import { Document, View, Page, Text, PDFViewer, Image, StyleSheet } from '@react-pdf/renderer';
import imagen_la_calandria from '../../../imagenes/imagen_la_calandria.jpg';
export default function RotulosPdf({numDocumento, cliente, ciudad, direccion, zona, rotuloNumero, rotulosTotal}){
    
    
    const styles = StyleSheet.create({
        contenedorPrincipal: {
            width:"118vh",
            height:"90vh",
        },
        imagen: {
            width: "100px",
            height: "100px",
        },  
        halfPage: {
            height: '50%',
            //borderBottom: '1px solid black',
            //padding: 10
        }
    })

    return (
        <>
        {/* <Document> */}
            <View style={styles.halfPage}>
                <View style={{marginHorizontal: "20px", marginVertical:"20px", fontSize:"30pt"}}>                    
                     <View style={{flexDirection:"row", justifyContent:"space-between", marginBottom:"45px"}}>                   
                    <Text style={{marginBottom:"45px"}}>La Calandria Envios</Text>                  
                    <Text>Bulto {rotuloNumero} / {rotulosTotal}</Text>
                    </View>
                    <Text style={{marginBottom:"45px"}}>Rto: {numDocumento}</Text>
                    <Text style={{marginBottom:"45px"}}>Zona: {zona}</Text>                            
                    <Text style={{marginBottom:"45px"}}>Cliente: {cliente}</Text>
                    <Text style={{marginBottom:"45px"}}>Ciudad: {ciudad}</Text>                
                    <Text style={{marginBottom:"45px"}}>Direccion: {direccion}</Text>                        
                
                </View>
            </View>
        {/* </Document> */}
        </>
    )
}